// src/pages/EWarehouse.jsx
import React from 'react';
import './EWarehouse.css'; // Make sure to import the CSS file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck, faChartLine, faSyncAlt, faLock, faWarehouse, faCog } from '@fortawesome/free-solid-svg-icons'; // Import icons

const EWarehouse = () => {
  return (
    <div className="e-warehouse">
      <h3>e-Warehouse Document Hub</h3>
      <div className="content-container">
        <div className="cardw">
          <FontAwesomeIcon icon={faClipboardCheck} className="icon" />
          <p>
            Our e-Warehouse solution is designed to revolutionize how you manage your Tally ERP document workflows, 
            bringing speed, accuracy, and paperless integration to every financial transaction.
          </p>
        </div>
        <div className="cardw">
          <FontAwesomeIcon icon={faWarehouse} className="icon" />
          <p>
            Dynamically generate unique, secure transaction QR codes directly in this web application. Scan the generated QR codes 
            using the e-Warehouse mobile companion app to capture and upload receipts on the go.
          </p>
        </div>
        <div className="cardw">
          <FontAwesomeIcon icon={faCog} className="icon" />
          <p>
            Upload and organize invoices, document PDFs, and transaction receipts directly through the web portal. 
            Manage all file archives and attachments in one consolidated system.
          </p>
        </div>
        <div className="cardw">
          <FontAwesomeIcon icon={faSyncAlt} className="icon" />
          <p>
            Real-time synchronization ensures that all documents uploaded via the web hub or captured by the companion mobile 
            scanner are immediately linked to your active Tally ERP transaction logs.
          </p>
        </div>
        <div className="cardw">
          <FontAwesomeIcon icon={faChartLine} className="icon" />
          <p>
            Maintain a flawless digital paper trail for corporate audits, tracking, and compliance. Eliminate physical paper clutter 
            and the risk of missing invoice attachments with our integrated dashboards.
          </p>
        </div>
        <div className="cardw">
          <FontAwesomeIcon icon={faLock} className="icon" />
          <p>
            Enterprise-grade security is standard, with role-based access control ensuring all sensitive financial attachments, 
            vendor invoices, and ledger documents are only accessible to authorized personnel.
          </p>
        </div>
        <div className="cardw">
          <FontAwesomeIcon icon={faClipboardCheck} className="icon" />
          <p>
            <strong>Tally Integration:</strong> e-Warehouse provides a highly requested document attachment bridge for Tally ERP users. 
            Whether uploading files from this web portal or scanning from the mobile companion app, attachment workflows are 
            fully automated, reliable, and secure.
          </p>
        </div>
      </div>
      <img 
        src={require("./ewarehouse.gif")} 
        alt="E-Warehouse platform" 
        className="warehouse-image" 
      />
    </div>
  );
};

export default EWarehouse;
